import React from "react";

import Input from "../../components/controls/Input";
import Button from "../../components/controls/Button";

import Logo from "../../assets/logo.png";
import { APP_NAME, APP_VERSION, USERNAME, PASSWORD } from "../../constants/app";
import { isEmptyOrWhiteSpace } from "../../helpers";
import { faUser, faKey } from "@fortawesome/free-solid-svg-icons";
import { Link } from "@material-ui/core";
import { enableContext } from "../../auth/secret";

export default class index extends React.Component {
  state = {
    username: "",
    password: "",

    isLoging: false,
  };

  componentDidMount() {
    document.addEventListener("keydown", this._handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this._handleKeyDown);
  }

  _handleKeyDown = (event) => {
    if (event.key === "Enter") {
      this._onLogin();
    }
  };

  _onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  _onLogin = () => {
    if (isEmptyOrWhiteSpace(this.state.username, this.state.password)) {
      if (this.state.username === USERNAME && this.state.password === PASSWORD) {
        window.localStorage.setItem(`${APP_NAME}-authToken`, `${APP_NAME}-access-token`);
        window.location.pathname = `${enableContext ? `/${APP_NAME}` : ""}/app/main`;
      } else alert("Incorrect username or password!");
    } else alert("Please input username and password!");
    // if (isEmptyOrWhiteSpace(this.state.username, this.state.password)) {
    //   let networkError = setTimeout(() => {
    //     this.setState({isLogging: false});
    //     alert("Oppps! Something went wrong while login, Please try again!");
    //   }, 4000);
    //   this.setState({isLogging: true}, () => {
    //     axios({
    //       url: `${baseUrl}/auth/login?password=${this.state.password}&username=${this.state.username}`,
    //       headers,
    //       method: "POST",
    //       timeout: 4000,
    //     })
    //       .then((resp) => {
    //         clearTimeout(networkError);
    //         this.setState({isLogging: false});
    //         if (resp.data.header.result) {
    //           //Turn secure on in production mode
    //           Cookies.set("authToken", resp.data.body.accessToken, {path: `/${APP_NAME}`, expires: 1, secure: false});
    //           Cookies.set("refreshToken", resp.data.body.refreshToken, {path: `/${APP_NAME}`, expires: 2, secure: false});
    //           axios({
    //             url: `${baseUrl}/user/me`,
    //             headers: {
    //               Authorization: `bearer ${resp.data.body.accessToken}`,
    //               Accept: "*/*",
    //             },
    //             method: "POST",
    //           }).then((resp) => {
    //             if (resp.data.header.result) {
    //               // this.setState({ isLogging: false })
    //               Cookies.set("user", resp.data.body.name, {expires: 1, secure: false});
    //               Cookies.set("userId", resp.data.body.id, {expires: 1, secure: false});
    //               Cookies.set("profile", resp.data.body.filename, {expires: 1, secure: false});
    //               window.location.pathname = `/${APP_NAME}`;
    //             }
    //           });
    //         } else {
    //           alert(resp.data.header.errorText);
    //         }
    //       })
    //       .catch((error) => console.error("timeout exceeded"));
    //   });
    // } else alert("Please input username and password!");
  };

  render() {
    return (
      <div style={{ width: "35%", minWidth: 300, maxWidth: 500 }}>
        <div className="ut-all-center" style={{ paddingBottom: 10 }}>
          <img src={Logo} alt="profile" style={{ height: 70, borderRadius: 10 }} />
        </div>
        <form
          className="ut-card ut-flex-column"
          onSubmit={(e) => {
            e.preventDefault();
            this._onLogin();
          }}
        >
          <h4 className="ut-title ut-color-primary" style={{ textAlign: "center" }}>
            Customer Support
          </h4>
          <Input leftIcon={faUser} name="username" placeholder="username" size="sm" onChange={this._onChange} value={this.state.username} />
          <Input leftIcon={faKey} name="password" placeholder="password" size="sm" onChange={this._onChange} value={this.state.password} type="password" />
          <Button name={this.state.isLoging ? "LOGIN..." : "LOGIN"} block size="sm" buttonStyle="filled" onClick={this._onLogin} textColor="#FFFFFF" />
          <div style={{ height: 10 }}></div>
          <Button name="Back to Home" block size="sm" buttonStyle="outline" onClick={() => this.props.history.push("/home")} />
        </form>
        <hr />
        <center>
          <span className="ut-info">Powered by: UDAYA Technology Co., Ltd. &copy; {new Date().getFullYear()} All rights reserved.</span>
        </center>
        <center>
          <span className="ut-info">
            <Link style={{ cursor: "pointer" }} onClick={() => this.props.history.push("/term-and-condition")}>
              Term and Condition
            </Link>{" "}
            |{" "}
            <Link style={{ cursor: "pointer" }} onClick={() => this.props.history.push("/privacy-policy")}>
              Privacy Policy
            </Link>
          </span>
        </center>
        <center>
          <span className="ut-info">Version: {APP_VERSION}</span>
        </center>
      </div>
    );
  }
}
